import { createStore } from 'vuex'
import apiEndPoint from '@/store/apiEndPoint'
import frFaq from './faq/frFaq'
import frFaqCategory from './faq/frFaqCategory'
import loadingHandler from './loadingHandler'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    apiEndPoint,
    frFaq,
    frFaqCategory,
    loadingHandler
  }
})
